package org.hs_soft.runmynesto.domain.model.general_error_model


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class GeneralError(
    @SerialName("extensions")
    val extensions: Extensions?=null,
    @SerialName("message")
    val message: String?=null,
    @SerialName("path")
    val path: List<String?>?=null,
)